import { combineReducers, configureStore, Store } from '@reduxjs/toolkit'
import {
  CellBrowsingReducer,
  CellVisualizationsReducer,
  NotificationReducer,
  PlotlyReducer,
  RemoteFlagsReducer,
  RunDetailsReducer,
  RunSearchFilterReducer,
  RunsReducer,
  SessionSearchFilterReducer,
  UserReducer,
  VisualizationReducer,
  WalkthroughReducer,
} from './slices'
import downloadsReducer from './slices/DownloadsSlice'
import { ErrorReducer } from './slices/ErrorSlice'
import { LabelingReducer } from './slices/LabelingSlice'

// Store setup, based on the sample code here that allows for easy integration testing:
// https://redux.js.org/usage/writing-tests#setting-up-a-reusable-test-render-function

const rootReducer = combineReducers({
  runSearchFilter: RunSearchFilterReducer,
  runs: RunsReducer,
  runDetails: RunDetailsReducer,
  user: UserReducer,
  cellVisualizations: CellVisualizationsReducer,
  notification: NotificationReducer,
  visualization: VisualizationReducer,
  plotly: PlotlyReducer,
  walkthrough: WalkthroughReducer,
  remoteFlags: RemoteFlagsReducer,
  cellBrowsing: CellBrowsingReducer,
  error: ErrorReducer,
  sessionSearchFilter:SessionSearchFilterReducer,
  downloads: downloadsReducer,
  labeling: LabelingReducer,
})

export const setupStore = (preloadedState?: Partial<RootState>): Store<RootState> => {
  return configureStore({
    reducer: rootReducer,
    middleware: [],
    preloadedState,
  })
}

export const store = setupStore()

export type RootState = ReturnType<typeof rootReducer>
export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore['dispatch']
